import type { MapMove, MovePhase } from './types';

// RENDER CAPS --------------------------------------------------------------- //

export const MAP_MAX_MOVES = 250;
export const MAP_MAX_DRIVERS = 75;

// COLOR PALETTES ------------------------------------------------------------ //

/** Past moves (bright cool tones) — high contrast on dark map */
export const PAST_COLORS = ['#60a5fa', '#a78bfa', '#38bdf8', '#93c5fd', '#c4b5fd', '#7dd3fc'];

/** Active move — solid route color */
export const ACTIVE_COLOR = '#60a5fa';

/** Future moves (bright warm tones) — high contrast on dark map */
export const FUTURE_COLORS = ['#fbbf24', '#fb923c', '#fcd34d', '#fdba74', '#f59e0b', '#fde68a'];

export const PICKUP_COLOR = '#22c55e';
export const DELIVERY_COLOR = '#ef4444';
export const DEVIATION_COLOR = '#f87171';
export const BREADCRUMB_COLOR = '#ffffff';

// ACTIVE-ROUTE STYLING ------------------------------------------------------ //

export const ACTIVE_GLOW_COLOR = '#3b82f6';
export const ACTIVE_DASH_COLOR = '#93c5fd';

// FLAG SVG PATH (Material Design flag icon, 24x24 viewbox) ------------------ //

export const FLAG_PATH = 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z';

// ACTIVE MOVE STATUSES ------------------------------------------------------ //

export const ACTIVE_STATUSES = new Set([
  'pickup started',
  'pickup arrived',
  'pickup successful',
  'delivery started',
  'delivery arrived',
]);

export function isActiveMoveStatus(status?: string): boolean {
  return !!status && ACTIVE_STATUSES.has(status);
}

// MOVE CLASSIFICATION ------------------------------------------------------- //

export function classifyMove(move: MapMove): MovePhase {
  if (move.delivery_successful) return 'past';
  if (isActiveMoveStatus(move.status)) return 'active';
  return 'future';
}

// MOVE COLOR MAP ------------------------------------------------------------ //

/** Build a status-based color map for a set of moves — uses classifyMove internally */
export function buildMoveColorMap(moves: MapMove[]): Record<number, string> {
  const map: Record<number, string> = {};
  let pastIdx = 0;
  let futureIdx = 0;
  moves.forEach(move => {
    const phase = classifyMove(move);
    if (phase === 'past') {
      map[move.id] = PAST_COLORS[pastIdx % PAST_COLORS.length];
      pastIdx++;
    } else if (phase === 'active') {
      map[move.id] = ACTIVE_COLOR;
    } else {
      map[move.id] = FUTURE_COLORS[futureIdx % FUTURE_COLORS.length];
      futureIdx++;
    }
  });
  return map;
}
